import Vue from "vue";
import App from "./App";
import router from "./router";
import { OktaAuth } from "@okta/okta-auth-js";
import OktaVue from "@okta/okta-vue";
import BootstrapVue from "bootstrap-vue";

import globals from "./globals";
import Popper from "popper.js";
import store from "./store";

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false;

Vue.config.productionTip = false;

const oktaAuth = new OktaAuth({
  issuer: process.env.VUE_APP_OKTA_ISSUER,
  clientId: process.env.VUE_APP_OKTA_CLIENTID,
  redirectUri: window.location.origin + "/login/callback",
  scopes: ["openid", "profile", "email", "groups"],
});
Vue.use(OktaVue, { oktaAuth });

Vue.use(BootstrapVue);

// Global RTL flag
Vue.mixin({
  data: globals
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
